"use client" 
import InputText from "@/components/Atoms/inputText"
import { IndigoButton, TealButton } from "@/components/Atoms/Buttons/ColorButtons";
import { useState } from "react";
import { useRouter } from "next/navigation";
import Alert from "@/components/Atoms/Alerts/Alert";
import { UIContext } from "@/contexts/UIContext";
import { useContext } from "react";


const InquiryForm = ({lang, requestType, notifyUserUUID, recordUUID, recordType, parentComponent, parentPath, buttonCaption, placeholderColor, darkBGValue,
     fieldFullName=false,
     fieldCompanyName=false,
     fieldPhoneNumber=false,
     fieldEmailAddress=false,
     fieldMessage=false,
     fieldMessagePresetValue

}) => { 

     const router = useRouter()


       const { supportModalOpen, setSupportModalOpen, sideNavbarPinned, setSideNavbarPinned, thisUser, success, setSuccess, error, setError } = useContext(UIContext);

     const initData = {
          message: fieldMessagePresetValue || null
     }
     let [data, setData] = useState(initData)
     let [missingFields, setMissingFields] = useState(null)


     const handleChange = (event) => {
          setData({
            ...data,
            [event.target?.name]: event.target?.value,
          });

     };

     // const postPutData = {
     //      full_name: data?.full_name,
     //      company_name: data?.company_name,
     //      phone_number: data?.phone_number,
     //      email_address: data?.email_address,
     //      message: data?.message,
     //      lang: lang,
     // }
           
     const handleSubmit = async () => {
     
     if (!data.email_address || data.email_address.length < 1) {
          setError({message: 'Email address cannot be empty'})
          return;
     }
     
     // console.log("data", data)
     const formData = new FormData();
     
     // Append all other data to the FormData object
     formData.append("full_name", data.full_name);
     formData.append("company_name", data.company_name);
     formData.append("phone_number", data.phone_number);
     formData.append("email_address", data.email_address);
     formData.append("message", data.message);    
     formData.append("lang", data.lang);
     formData.append("parent_component", parentComponent)
     formData.append("parent_path", parentPath)
     formData.append("notification_recipient_user_uuid", notifyUserUUID)
     formData.append("record_uuid", recordUUID)
     formData.append("record_type", recordType)
     formData.append("request_type", requestType)
     // formData.append("")


     // const requiredFields = [ 'first_name', 'last_name', 'email_address' ]
     // requiredFields.forEach(field => {if (!postPutData[field]){ setMissingFields({missingFields, [field]: true}) }})
     
          
     try {
          let apiUrl = `/api/inquiry/`;
          let response = await fetch(apiUrl, {
          method: 'POST',
          credentials: 'include', // Keep this if you need cookies sent
          body: formData, // Send formData object
          });
     
          response = await response.json();
          console.log(response);
          setSuccess({message: lang === 'fr' ? 'Requête envoyée' : 'Inquiry sent'})
          setData(initData)
          router.push('?')
          // callback('closeModal');


     
     } catch (error) {
          console.log('error', error);
          setError({message: lang === 'fr' ? "La requête n'a pue être envoyée" : 'Inquiry could not be sent'})
     } 
     
     };

     return (
          <div className={`bg-white ${darkBGValue} dark:text-gray-300 rounded-b-3xl p-4 text-center`}>
               <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>
          <div className="space-y-2">

          {fieldFullName && <InputText darkBGValue={placeholderColor || 'dark:bg-slate-900'} name='full_name' error={missingFields === 'full_name' ? true : false} data={{type: 'text', id:'full_name', value: data?.full_name, onChange: handleChange, label: `${lang === 'fr' ? 'Votre Nom Complet' : 'Your Full Name'}`}}/>}

          {fieldCompanyName && <InputText name="company_name" darkBGValue={placeholderColor || 'dark:bg-slate-900'} error={missingFields === 'company_name' ? true : false} data={{type: 'text', id:'company_name', value: data?.company_name, onChange: handleChange, label: `${lang === 'fr' ? 'Nom de votre Entreprise' : 'Your Company Name'}`}}/>}

          {fieldEmailAddress && <InputText  darkBGValue={placeholderColor || 'dark:bg-slate-900'} name='email_address' error={missingFields === 'email_address' ? true : false} data={{type: 'text', id:'email_address', value: data?.email_address, onChange: handleChange, label: `${lang === 'fr' ? 'Votre Adresse Courriel' : 'Your Email Address'}`}}/>}

          {fieldPhoneNumber && <InputText darkBGValue={placeholderColor || 'dark:bg-slate-900'} name='phone_number' error={missingFields === 'phone_number' ? true : false} data={{type: 'text', id:'phone_number', value: data?.phone_number, onChange: handleChange, label: `${lang === 'fr' ? 'Votre Numéro de Téléphone' : 'Your Phone Number'}`,}}/>}

            {fieldMessage && <textarea
    rows="10"
    className="mt-2 w-full resize-none dark:bg-inherit mb-4 appearance-none border font-inter placeholder-gray-500 border-slate-300 dark:text-white dark:border-slate-600 rounded-lg py-2 px-3 leading-tight focus:outline-none focus:shadow-outline text-sm"
    id="message"
    value={data?.message || fieldMessagePresetValue}
    onChange={handleChange}
    name="message"
    placeholder={lang === 'fr' ? `Votre Message...` : `Your Message...`}
  />  }

   <div className="text-right">

        <TealButton border={true} onClick={handleSubmit} caption={buttonCaption} textSize={'text-lg'}/>

   </div>
   </div>
   </div>
     )
}

export default InquiryForm